import useAppStore from "@/context/store";
import { useCallback } from "react";
import HBList from "../HBList";
import UserCard from "../UserCard";
import UserLineCard from "../UserCard/line";

export default function UserList({
  type = "card",
  onFollow,
  hideTime,
  ...props
}) {
  const { column, columnSize } = useAppStore(({ column, columnSize }) => ({
    column,
    columnSize,
  }));

  const render = useCallback(
    (record, index) => {
      if (type === "line") {
        return (
          <UserLineCard
            key={record.user_id}
            record={record}
            onFollow={onFollow}
          />
        );
      } else {
        return (
          <UserCard
            key={record.user_id}
            record={record}
            hideTime={hideTime}
            onFollow={onFollow}
            columnSize={columnSize}
            grayFollow
            style={
              props.disableMasonry
                ? { marginRight: (index + 1) % column !== 0 ? "16px" : "" }
                : null
            }
          />
        );
      }
    },
    [column, columnSize, hideTime, onFollow, props.disableMasonry, type]
  );

  return (
    <HBList
      {...props}
      disableMasonry={props.disableMasonry || type === "line"}
      loginGuide={true}
      uniqueKey="user_id"
      render={render}
      masonryOptions={{
        columnNum: column,
        columnSize: columnSize,
        brickId: "user_id",
        masonryKey: props.masonryKey,
      }}
    />
  );
}
